export const COUNTRY_CODES = [
  "AT",
  "DE",
  "CH",
  "AF",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AG",
  "AR",
  "AM",
  "AZ",
  "AU",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BT",
  "BO",
  "BA",
  "BW",
  "BR",
  "BN",
  "BG",
  "BF",
  "BI",
  "CV",
  "CL",
  "CN",
  "CR",
  "CD",
  "DM",
  "DO",
  "DJ",
  "DK",
  "EC",
  "SV",
  "CI",
  "ER",
  "EE",
  "SZ",
  "FJ",
  "FI",
  "FR",
  "GA",
  "GM",
  "GE",
  "GH",
  "GD",
  "GR",
  "GT",
  "GN",
  "GW",
  "GY",
  "HT",
  "HN",
  "IN",
  "ID",
  "IQ",
  "IR",
  "IE",
  "IS",
  "IL",
  "IT",
  "JM",
  "JP",
  "YE",
  "JO",
  "KH",
  "CM",
  "CA",
  "KZ",
  "QA",
  "KE",
  "KG",
  "KI",
  "CO",
  "KM",
  "HR",
  "CU",
  "KW",
  "LA",
  "LS",
  "LV",
  "LB",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MA",
  "MH",
  "MR",
  "MU",
  "MX",
  "FM",
  "MD",
  "MC",
  "MN",
  "ME",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NZ",
  "NI",
  "NL",
  "NE",
  "NG",
  "KP",
  "MK",
  "NO",
  "OM",
  "PK",
  "PW",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PL",
  "PT",
  "CG",
  "RW",
  "RO",
  "RU",
  "SB",
  "ZM",
  "WS",
  "SM",
  "SA",
  "SE",
  "SN",
  "RS",
  "SC",
  "SL",
  "ZW",
  "SG",
  "SK",
  "SI",
  "SO",
  "ES",
  "LK",
  "KN",
  "LC",
  "VC",
  "SD",
  "SR",
  "SY",
  "ST",
  "ZA",
  "KR",
  "SS",
  "TJ",
  "TW",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TO",
  "TT",
  "TD",
  "CZ",
  "TN",
  "TM",
  "TV",
  "TR",
  "UG",
  "UA",
  "HU",
  "UY",
  "UZ",
  "VU",
  "VA",
  "VE",
  "AE",
  "US",
  "GB",
  "VN",
  "CF",
  "CY",
  "EG",
  "GQ",
  "ET",
] as const;

export type CountryCode = (typeof COUNTRY_CODES)[number];

